module.exports = __webpack_public_path__ + "img/cangku.d59d365a.png";